const ALIASES = {
  bac: "MB",
  bắc: "MB",
  mb: "MB",
  xsmb: "MB",
  "mien-bac": "MB",
  "mien bac": "MB",
  "miền bắc": "MB",
  trung: "MT",
  mt: "MT",
  xsmt: "MT",
  xmst: "MT",
  "mien-trung": "MT",
  "mien trung": "MT",
  "miền trung": "MT",
  nam: "MN",
  mn: "MN",
  xsmn: "MN",
  "mien-nam": "MN",
  "mien nam": "MN",
  "miền nam": "MN",
};

export const STATION_OPTIONS = [
  { value: "MB", label: "Bắc", full: "Miền Bắc", alias: "bac" },
  { value: "MT", label: "Trung", full: "Miền Trung", alias: "trung" },
  { value: "MN", label: "Nam", full: "Miền Nam", alias: "nam" },
];

export function resolveStation(raw, fallback = "MB") {
  if (!raw) return fallback;
  const key = String(raw).trim().toLowerCase();
  if (ALIASES[key]) return ALIASES[key];
  const upper = key.toUpperCase();
  if (upper === "MB" || upper === "MT" || upper === "MN") return upper;
  return fallback;
}
